<template>
  <div v-if="experiments['experiment.ppTelcoCalculator'] === 'withCalculator'">
    <button
      class="relative mt-12 w-full"
      @click="openModal(MODAL_NAMES.TELCO_CALCULATOR)"
    >
      <div
        class="absolute -top-12 left-24 border-x-12 border-b-12 border-solid border-x-transparent border-b-[#ECEEF2]"
      />
      <div
        class="bg-static-default-mid rounded-lg relative flex items-center gap-8 p-8"
      >
        <slot name="icons" />
        <div class="flex grow items-center justify-between">
          <div>
            <div class="body-2-bold">{{ i18n(translations.title) }}</div>
            <div class="caption">{{ i18n(translations.subtitle) }}</div>
          </div>
          <IconChevronRight />
        </div>
      </div>
    </button>
    <TelcoCalculatorModal />
  </div>
</template>

<script setup lang="ts">
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { MODAL_NAMES } from '~/scopes/product/constants'

import translations from './TelcoCalculatorAdvertisement.translations'
import TelcoCalculatorModal from './components/TelcoCalculatorModal/TelcoCalculatorModal.vue'

const i18n = useI18n()

const experiments = useExperiments()
</script>
